import React, { useState, useEffect } from 'react';

export default function FontsPanel({ backendUrl }) {
  const [fonts, setFonts] = useState([]);
  const [error, setError] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [newFontName, setNewFontName] = useState('');
  const [newFontFile, setNewFontFile] = useState(null);

  // Ładowanie listy czcionek
  useEffect(() => {
    fetchFonts();
    // eslint-disable-next-line
  }, []);

  const fetchFonts = () => {
    fetch(`${backendUrl}/admin/fonts`, { credentials: 'include' })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Błąd pobierania listy czcionek.');
        }
        return res.json();
      })
      .then((data) => {
        setFonts(data);
        setError('');
      })
      .catch((err) => {
        console.error(err);
        setError('Nie udało się pobrać czcionek.');
      });
  };

  const handleAddFontClick = () => {
    setShowAddForm((prev) => !prev);
    setError('');
    setNewFontName('');
    setNewFontFile(null);
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setNewFontFile(e.target.files[0]);
    }
  };

  const handleAddFontSubmit = (e) => {
    e.preventDefault();
    if (!newFontName) {
      setError('Podaj nazwę czcionki!');
      return;
    }
    if (!newFontFile) {
      setError('Wybierz plik czcionki .ttf lub .otf!');
      return;
    }

    const formData = new FormData();
    formData.append('fontName', newFontName);
    formData.append('fontFile', newFontFile);

    fetch(`${backendUrl}/admin/fonts`, {
      method: 'POST',
      credentials: 'include',
      body: formData
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Błąd podczas zapisu nowej czcionki.');
        }
        return res.json();
      })
      .then((data) => {
        // Dodajemy nową czcionkę do listy w pamięci
        setFonts((prev) => [...prev, data]);
        setShowAddForm(false);
      })
      .catch((err) => {
        console.error(err);
        setError('Nie udało się dodać czcionki.');
      });
  };

  // === NOWA FUNKCJA USUWANIA CZCIONKI ===
  const handleDeleteFont = async (id) => {
    setError('');
    try {
      const res = await fetch(`${backendUrl}/admin/fonts/${id}`, {
        method: 'DELETE',
        credentials: 'include'
      });
      if (!res.ok) {
        throw new Error('Błąd usuwania czcionki.');
      }
      await res.json(); // oczekujemy { message: 'Font usunięty' } w odpowiedzi

      // Usuwamy ją z listy w state
      setFonts((prev) => prev.filter((font) => font.id !== id));
    } catch (err) {
      console.error('[handleDeleteFont]', err);
      setError('Nie udało się usunąć czcionki.');
    }
  };

  return (
    <div className="orders-container" style={{ marginTop: '20px' }}>
      <h3>Lista Czcionek</h3>
      {error && <p className="dashboard-error">{error}</p>}

      <button className="orders-add-btn" onClick={handleAddFontClick}>
        {showAddForm ? 'Anuluj' : 'Dodaj czcionkę'}
      </button>

      {showAddForm && (
        <form onSubmit={handleAddFontSubmit} className="orders-add-form">
          <div className="orders-form-group">
            <label>Nazwa czcionki:</label>
            <input
              type="text"
              value={newFontName}
              onChange={(e) => setNewFontName(e.target.value)}
              className="orders-input"
              required
            />
          </div>
          <div className="orders-form-group">
            <label>Plik (TTF/OTF):</label>
            <input
              type="file"
              accept=".ttf,.otf"
              onChange={handleFileChange}
              className="orders-input"
            />
          </div>
          <button type="submit" className="orders-button">
            Zapisz
          </button>
        </form>
      )}

      {fonts.length === 0 ? (
        <p style={{ marginTop: '15px' }}>Brak czcionek w bazie.</p>
      ) : (
        <table className="orders-table" style={{ marginTop: '15px' }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nazwa</th>
              <th>Plik</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            {fonts.map((font) => (
              <tr key={font.id}>
                <td>{font.id}</td>
                <td>{font.name}</td>
                <td>{font.filePath}</td>
                <td>
                  <button
                    style={{
                      backgroundColor: '#d9534f',
                      color: '#fff',
                      border: 'none',
                      padding: '6px 12px',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                    onClick={() => handleDeleteFont(font.id)}
                  >
                    Usuń
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
